export async function fetchHtml(input: RequestInfo): Promise<string> {
	const response = await fetch(input, {
		method: 'GET',
	});
	if (response.headers.get('content-type')?.includes('text/html')) {
		return response.text();
	}

	return new Promise<string>((resolve, reject) =>
		reject(Error('Response does not contain content-type text/html'))
	);
}
